import { DataGridColumn } from '@/components/DataGrid/DataGridColumn.class';
import { DataGridColumnType } from '@/components/DataGrid/DataGridColumnType.class';
import { Trip } from '@/typing/api/tripNew.class';
import $dayjs from '@/utils/dayjs';

export const numberFiller = (): any => '0';
export const timeFiller = (): any => $dayjs().format('HH:mm');
export const dateFiller = (): any => $dayjs().format('DD/MM/YYYY');
export const datePickerFiller = (
    t: Trip,
    column: DataGridColumn,
    columns: DataGridColumn[]
): any => {
    const dateColumns = columns.filter(
        x => x.additionalInputType === DataGridColumnType.TimeDate
    );
    const currentColumnIndex = dateColumns.findIndex(
        x => x.valueKey === column.valueKey
    );

    if (currentColumnIndex === 0) {
        return $dayjs(t.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    } else {
        const prevColumn = dateColumns[currentColumnIndex - 1];
        const dateKey = prevColumn.dateValueKey ?? '';
        const valueKey = prevColumn.valueKey ?? '';
        const prevDate = (t as any)[dateKey];
        const prevTime = (t as any)[valueKey];
        const prevValue = $dayjs(`${prevDate} ${prevTime}`);

        const currentDateString = prevDate;
        const currentTime = (t as any)[column.valueKey];

        let currentDate = $dayjs(`${currentDateString} ${currentTime}`);

        if (currentDate < prevValue) {
            currentDate = currentDate.add(1, 'day');
        }

        return currentDate.format('YYYY-MM-DD');
    }
};
